const SlideHeight = (() => {

    const DOM = {};

    const cacheDOM = () => {
        DOM.image = document.getElementsByClassName('slide-image');
        DOM.container = document.getElementsByClassName('swiper-container');
        DOM.height = DOM.image[0].clientHeight;
    };

    const eventlistener = () => {
        window.onload = () => {
            setHeight();
        };
    };

    const setHeight = () => {
        console.log(DOM.height);
        // DOM.container[0].setAttribute('style', `height : ${DOM.height}px`);
    }

    const init = () => {
        cacheDOM();
        eventlistener();

    };

    return {
        init

    }
})();

export default SlideHeight;


